// Module
var code = "<div class=\"top-menu__item uip-item\"> <div class=\"uip-item__icon\"></div> </div>";
// Exports
module.exports = code;